import styled from 'styled-components';

const base = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.colors.background};
  width: 100%;
  height: 100vh;
`;

const app = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 0 0 11rem;
  width: 100%;
  height: fit-content;
  background-color: ${(props) => props.theme.colors.background};
`;

const Frame = {
  Base: base,
  App: app,
};

export default Frame;
